import * as Yup from 'yup'
import LookupType from './LookupType'

export const PurchaseOrderLineItemSchema = Yup.object().shape({
    id: Yup
    .number(),

    purchase_order_id: Yup
    .string(),

    product: LookupType
    .label('Product')
    .default(null)
    .nullable()
    .required(),

    quantity: Yup
    .number()
    .label('Quantity')
    .min(1, 'Quantity is required')
    .required(),

    order_unit: LookupType
    .label('Order Unit')
    .nullable(),

    unit_cost: Yup
    .number()
    .label('Cost')
    .required()
    .min(0.01, 'Cost is required'),

    items_per_unit: Yup
    .number()
    .nullable()
    .label('Items Per Unit'),

    date_received: Yup
    .string()
    .label('Date Received')
    .nullable()

})

export const PurchaseOrderSchema = Yup.object().shape({
    order_name: Yup
        .string()
        .label('Order Name')
        .required(),

    supplier: LookupType
        .label('Vendor')
        .default(null)
        .nullable()
        .required('Vendor is required'),

    mmg_location: LookupType
        .label('Shipping')
        .nullable(),

    created_by: LookupType
        .label('Order By')
        .default(null)
        .nullable()
        .required('Order by is required'),

    order_status: LookupType
        .label('Order Status')
        .nullable(),

    order_date: Yup
        .string()
        .label('Order Date')
        .nullable(),

    expected_date: Yup
        .string()
        .label('Expected Date')
        .nullable(),

    notes: Yup
        .string()
        .label('Notes')
        .nullable(),

    pickup_number: Yup
        .string()
        .label('Pickup No')
        .nullable(),

    purchase_order_line_items: Yup
        .array()
        .of(PurchaseOrderLineItemSchema)
        .min(1)
        .required('At least one item is required')
})
